import { render } from "./Index.vue?vue&type=template&id=390ce5ee"
import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/AssetGroups/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "390ce5ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('390ce5ee', __exports__)) {
    console.log('reload')
    api.reload('390ce5ee', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=390ce5ee", () => {
    console.log('re-render')
    api.rerender('390ce5ee', render)
  })

}


export default __exports__